import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Validators} from '../../../components/_common/_form/Validators'
import NRTHorizontalStack from '../../../components/_common/_containers/HorizontalStack'
import NRTVerticalStack from '../../../components/_common/_containers/VerticalStack'
import NRTFormContainer from '../../../components/_common/_form/_containers/FormContainer'
import NRTFormInput from '../../../components/_common/_form/FormInput'
import NRTButton from '../../../components/_common/_buttons/Button'
import CirclePlus from '../../../components/_common/_icons/CirclePlus'

class MCSaleFormGuest extends Component {
    state = {}


    updateGuestInfo(personDTO) {

        if (!personDTO)
            return

        Object.keys(personDTO).forEach(k => {
            const formInput = this.refs[`${k}Input`]

            if (formInput)
                formInput.setValue(personDTO[k])
        })

    }

    reset() {
        Object.keys(this.refs)
            .map(k=>this.refs[k])
            .filter(input=>!!input.state.value)
            .forEach(input=>input.setValue(''))

    }


    render() {
        const {cpfCnpj, name, email, profession, phoneOne, phoneTwo} = this.props.guest

        const {onAddGuest} = this.props

        return (
            <div>
                <NRTFormContainer title={'Novo Participante'}>
                    <NRTVerticalStack>
                        <NRTFormInput ref={'codeInput'} name={'code'} customProps={{type: 'hidden'}}/>

                        <NRTFormInput name={'cpfCnpj'}
                                      label={'CPF*'}
                                      type={'cpf'} value={cpfCnpj || ''}
                                      validators={[Validators.cpf()]}/>

                        <NRTFormInput
                            name={'name'}
                            ref={'nameInput'}
                            label={'Nome Completo*'}
                            value={name || ''}
                            validators={[Validators.required()]}
                        />

                        <NRTFormInput name={'email'}
                                      ref={'emailInput'}
                                      label={'Email*'}
                                      value={email || ''}
                                      validators={[Validators.email()]}/>

                        <NRTFormInput name={'profession'}
                                      ref={'professionInput'}
                                      label={'Profissão'}
                                      value={profession || ''}/>

                        <NRTHorizontalStack fractions={[1, 1]}>
                            <NRTFormInput
                                name={'phoneOne'}
                                ref={'phoneOneInput'}
                                label={'Tel 1*'}
                                value={phoneOne || ''}
                                type={'phone'}
                                validators={[Validators.phone(), Validators.required()]}
                            />

                            <NRTFormInput name={'phoneTwo'} ref={'phoneTwoInput'} label={'Tel 2'} value={phoneTwo || ''}
                                          type={'phone'}/>
                        </NRTHorizontalStack>

                        <NRTButton onClick={onAddGuest} secondary>
                            <CirclePlus/>
                            Adicionar
                        </NRTButton>
                    </NRTVerticalStack>
                </NRTFormContainer>
            </div>
        )
    }
}

MCSaleFormGuest.propTypes = {
    guest: PropTypes.object,
    onAddGuest: PropTypes.func
}

MCSaleFormGuest.defaultProps = {}

export default MCSaleFormGuest



// WEBPACK FOOTER //
// ./src/components/_sale/FormGuest/index.js